export default {
  en: {
    buttons: {
      save: "Save",
      confirm: "Confirm",
      continue: "Continue",
      login: "Login",
      send: "Send",
      sending: "Sending...",
      back_to_home: "Back to home",
      ok: "Ok",
      cancel: "Cancel",
      accept: "Accept",
      close: "Close",
      add: "Add",
      delete: "Delete"
    },
    caution: "Caution",
    success: "Success",
    unexpected_error: "Unexpected error.",
    mccain_privacy_policy_link: "https://www.mccain.com/privacy",
    sold_tos: {
      loading: "Loading...",
      placeholder: "Select an option",
      label: "Select Sold To",
      required: "You must select a Sold To to continue.",
    },
    order_attachment: {
      title: "Attachment - Purchase Order",
      required_hint: "Attaching a file is required to place the order.",
      optional_hint: "You can attach a file to the order.",
      formats_hint: "Allowed formats: {formats}.",
      size_hint: "Maximum size: {size} MB.",
      upload: "Attach file",
      uploading: "Uploading...",
      download: "Download attachment",
      none: "No attachments",
      item: "Attachment {n}",
      confirm_delete_title: "Delete attachment",
      confirm_delete_text: "Are you sure you want to delete this attachment?",
      not_found: "The attachment is not available.",
      ORDER_ATTACHMENT_REQUIRED: "You must attach a file before placing the order.",
      ORDER_ATTACHMENT_INVALID_TYPE: "Invalid file format. Only PNG, JPG and PDF are allowed.",
      ORDER_ATTACHMENT_TOO_LARGE: "The file exceeds the maximum allowed size.",
      ORDER_ATTACHMENT_MISSING: "No file was received.",
      ORDER_ATTACHMENT_DISABLED: "Attachments are not enabled.",
    },
  },
  es: {
    buttons: {
      save: "Guardar",
      confirm: "Confirmar",
      continue: "Continuar",
      login: "Ingresar",
      send: "Enviar",
      sending: "Enviando...",
      back_to_home: "Volver a página de inicio",
      ok: "Entendido",
      cancel: "Cancelar",
      accept: "Aceptar",
      close: "Cerrar",
      add: "Agregar",
      delete: "Eliminar"
    },
    caution: "Atención",
    success: "Éxito",
    unexpected_error: "Error inesperado.",
    mccain_privacy_policy_link: "https://www.mccain.com/privacy/es-la",
    sold_tos: {
      loading: "Cargando...",
      placeholder: "Seleccione una opción",
      label: "Seleccione Sold To",
      required: "Debe seleccionar un Sold To para continuar.",
    },
    order_attachment: {
      title: "Adjunto - Orden de Compra",
      required_hint: "Es obligatorio adjuntar un archivo para realizar el pedido.",
      optional_hint: "Puede adjuntar un archivo al pedido.",
      formats_hint: "Formatos permitidos: {formats}.",
      size_hint: "Tamaño máximo: {size} MB.",
      upload: "Adjuntar archivo",
      uploading: "Subiendo...",
      download: "Descargar adjunto",
      none: "Sin adjuntos",
      item: "Adjunto {n}",
      confirm_delete_title: "Eliminar adjunto",
      confirm_delete_text: "¿Está seguro que desea eliminar este adjunto?",
      not_found: "El adjunto no está disponible.",
      ORDER_ATTACHMENT_REQUIRED: "Debe adjuntar un archivo antes de realizar el pedido.",
      ORDER_ATTACHMENT_INVALID_TYPE: "Formato de archivo inválido. Solo se permiten PNG, JPG y PDF.",
      ORDER_ATTACHMENT_TOO_LARGE: "El archivo supera el tamaño máximo permitido.",
      ORDER_ATTACHMENT_MISSING: "No se recibió ningún archivo.",
      ORDER_ATTACHMENT_DISABLED: "Los adjuntos no están habilitados.",
    }
  }
}